import { ProductBatchTypeEnum } from "@c2b/muven-commons"
import axios from "axios"
import { orderBy } from "lodash"
import { API_ADMIN } from "../../utils/constants/Api"
import { IFilter } from "../../utils/interfaces/FilterInterface"
import { ProductBatchItemModel } from "../models/ProductBatchItemModel"
import { ProductBatchItemLogModel } from "../models/ProductBatchItemLogModel"
import { ProductBatchItemWithLogsModel } from "../models/ProductBatchItemWithLogsModel"
import { ProductBatchModel } from "../models/ProductBatchModel"
import { ProductBatchItemFromFileUpdatePriceModel } from "../models/ProductBatchItemFromFileUpdatePriceModel"
import { ProductBatchItemFromFileUpdateStockPercentualModel } from "../models/ProductBatchItemFromFileUpdateStockPercentualModel"

interface BatchExecutuionAction {
    [key:string]: any;
}

interface ProductInfo {
    [key: string]: any;
}

export default {
    addItems(batch: ProductBatchModel, filter: IFilter):Promise<ProductBatchItemModel[]|ProductBatchItemWithLogsModel> {
        return axios.post(`${API_ADMIN}products/batches/${batch.id}/items/add${filter.toQueryString()}`)
            .then(({data}) => {
                switch (batch.batchType) {
                    case ProductBatchTypeEnum.BlockStock:
                    case ProductBatchTypeEnum.UpdateChannelPricePercentage:
                    case ProductBatchTypeEnum.UpdateChannelStockPercentage:
                        return (data || []).map((p: ProductBatchItemModel) => new ProductBatchItemModel(p, batch.batchType as ProductBatchTypeEnum))

                    case ProductBatchTypeEnum.UpdateChannelPriceValue:
                        return new ProductBatchItemWithLogsModel(data, batch.batchType)
                }
            })
    },
    getBatchItems(batch: ProductBatchModel):Promise<ProductBatchItemModel[]|ProductBatchItemWithLogsModel> {
        return axios.get(`${API_ADMIN}products/batches/${batch.id}/items`)
            .then(({data}) => {
                return (data || []).map((p: ProductBatchItemModel) => {
                    return new ProductBatchItemModel(p, batch.batchType as ProductBatchTypeEnum)
                })
            })
    },
    addItemsFromFileUpdatePrice(batch: ProductBatchModel, itemListInfo: ProductBatchItemFromFileUpdatePriceModel[]):Promise<ProductBatchItemWithLogsModel> {
        return axios.post(`${API_ADMIN}products/batches/${batch.id}/items/add_update_price`, itemListInfo)
            .then(({data}) => {
                return new ProductBatchItemWithLogsModel(data, batch.batchType as ProductBatchTypeEnum)
            })
    },

    addItemsFromFileUpdateStockPercentual(batch: ProductBatchModel, itemListInfo: ProductBatchItemFromFileUpdateStockPercentualModel[]):Promise<ProductBatchItemWithLogsModel> {
        return axios.post(`${API_ADMIN}products/batches/${batch.id}/items/add_stock_percentage`, itemListInfo)
            .then(({data}) => {
                return new ProductBatchItemWithLogsModel(data, batch.batchType as ProductBatchTypeEnum)
            })
    },

    getBatchItemsLogs(batch: ProductBatchModel):Promise<ProductBatchItemLogModel[]> {
        return axios.get(`${API_ADMIN}products/batches/${batch.id}/logs`)
            .then(({data}) => {
                return (data || []).map((log: ProductBatchItemLogModel) => new ProductBatchItemLogModel(log))
            })
    },
    createBatch(batch: ProductBatchModel):Promise<ProductBatchModel> {
        return axios.post(`${API_ADMIN}products/batches`, batch)
            .then(({data}) => {
                return new ProductBatchModel(data)
            })
    },
    updateBatch(batchId: number, batch: ProductBatchModel):Promise<ProductBatchModel> {
        return axios.put(`${API_ADMIN}products/batches/${batchId}`, batch)
            .then(({data}) => {
                return new ProductBatchModel(data)
            })
    },
    updateBatchItemProduct(batch: ProductBatchModel, productId: number, productInfo: ProductInfo):Promise<ProductBatchItemModel> {
        return axios.put(`${API_ADMIN}products/batches/${batch.id}/items/${productId}`, productInfo)
            .then(({data}) => {
                return new ProductBatchItemModel(data, batch.batchType as ProductBatchTypeEnum)
            })
    },
    getBatchList():Promise<ProductBatchModel[]> {
        return axios.get(`${API_ADMIN}products/batches`)
            .then(({data}) => {
                return (data || []).map((b:ProductBatchModel) => new ProductBatchModel(b))
            })
    },
    getBatchById(batchId: number):Promise<ProductBatchModel> {
        return axios.get(`${API_ADMIN}products/batches/${batchId}`)
            .then(({data}) => {
                return new ProductBatchModel(data)
            })
    },
    deleteBatch(batchId: number):Promise<any> {
        return axios.delete(`${API_ADMIN}products/batches/${batchId}`)
    },
    deleteItemFromBatch(batchId: number, itemId: number):Promise<any> {
        return axios.delete(`${API_ADMIN}products/batches/${batchId}/items/${itemId}`)
    },
    clearBatchItemList(batchId: number):Promise<any> {
        return axios.post(`${API_ADMIN}products/batches/${batchId}/clear`)
    },
    executeBatchAction(batchId: number, batch: BatchExecutuionAction):Promise<any> {
        return axios.post(`${API_ADMIN}products/batches/${batchId}/execute_action`, batch)
    },
}
